import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mrpricing',
  templateUrl: './mrpricing.component.html',
  styleUrls: ['./mrpricing.component.css']
})
export class MrpricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
